module.exports = __webpack_public_path__ + "img/FI21104714.97b49792.png";